import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { CreateNewSurveyRPC } from "./createNewSurveyRPC";

export class CreateNewSurveyRPCClientImpl extends CreateNewSurveyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: CreateNewSurveyRPC.Request): Promise<LeoRPCResult<CreateNewSurveyRPC.Response, CreateNewSurveyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/CreateNewSurvey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      CreateNewSurveyRPC.ResponseDTO,
      CreateNewSurveyRPC.Errors.ErrorsDTO,
      CreateNewSurveyRPC.Response,
      CreateNewSurveyRPC.Errors.Errors
    >(
      response,
      "survey/CreateNewSurvey",
      CreateNewSurveyRPC.Response.fromDTO,
      CreateNewSurveyRPC.Errors.fromDTO
    );
  }
}
